<template>
  <div>
    <commBanner :obj="obj"></commBanner>
    <breadCrum :breadCrumList="breadCrumList"></breadCrum>
    <div class="industry_information_content warp">
      <div class="info_detail" v-if="newsInfo">
        <h2>{{ newsInfo.title }}</h2>
        <div class="info_detail_tips">
          <div class="info_detail_date">
            <span v-if="newsInfo.releaseDate">{{ newsInfo.releaseDate.substring(0, 10)}}</span>
            <span>来源：{{ newsInfo.source }}</span>
            <span>阅读量：{{ newsInfo.readCount }}</span>
          </div>
          <user-operation
            v-if="newsInfo.title"
            @onCollection="goCollection()"
            @callCollection="callCancelcollection()"
            :shareObj="newsInfo"
            :notStatus="status"
            class="user_operation"
          ></user-operation>
        </div>
        <div class="info_detail_line"></div>
        <div
          class="info_detail_desc"
          v-html="newsInfo.content"
        ></div>

        <!--声明-->
        <div class="info_detail_statement">
          智污邦声明：此资讯系转载自智污邦环保服务平台合作媒体或互联网其它网站，本站登载此文出于传递更多信息之目的，并不意味着赞同其观点或证实其描述。文章内容仅供参考。
        </div>

        <div class="info_detail_next" @click="tonextdetail(nextid)">
          下一篇：{{ nexttitle }}
        </div>
        <div class="info_detail_line"></div>
        <comment :id="newsInfo.id"></comment>
      </div>
      <!--右边-->
      <div class="industry_information_recommender">
        <newsRecommend
          :newsRecommendObj="newsRecommendObj"
          @dataRefresh="getRecommendRandomList(4)"
          urlType="info_detail"
        ></newsRecommend>
        <div class="find_right" v-if="advList.length > 0">
          <a :href="'//' + advList[0].url" target="_blank">
            <img :src="advList[0].image" alt="" />
            <span>广告</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getRandomArray } from "@/utils/index";
import {
  getIndustryinfoList,
  getIndustryinfoById,
  getAdv,
} from "@/api/information";
import { addCollection, iscollection,cancelcollection} from "@/api/coment";
import { getToken } from "@/utils/auth";
import commBanner from "../../common/commBanner";
import newsRecommend from "../../common/newsRecommend";
import userOperation from "../../common/userOperation";
import comment from "../../common/comment";
import breadCrum from "../../common/breadCrum";
export default {
  inject: ["reload"], //注入App里的reload方法
  components: {
    commBanner,
    newsRecommend,
    userOperation,
    comment,
    breadCrum,
  },
  data() {
    return {
      obj: {
        title: "资讯详情",
        roleType: "",
        personalType: 1,
        // content:
        //   "公司主营产品及服务包括：金属氧化物避雷器带电检测仪、数字式钳形伏安相位表、大型地网接地电阻测量仪、多通道波形记录仪、PT感应耐压试验电源、高压高稳定电源...",
        // bannerUrl: require("@/assets/images/banner.jpg"),
      },
      breadCrumList: [
        { name: "行业资讯", url: "/industry_information" },
        { name: "资讯详情", url: "" },
      ],
      newsRecommendObj: {
        title: "推荐资讯",
        text: "换一批",
        isImg: true,
        newData: [],
      },
      newsInfo: "",
      allList: [],
      advType: 3,
      advList: [],
      status: false,
      nextid: null,
      nexttitle: "",
    };
  },
  created() {
    this.getRecommendIndustryinfoList();
    this.getAdv();
    if (getToken() != undefined) {
      this.getIscollection();
    }
    if (this.$store.state.user.userInfo != null) {
      let type = this.$store.state.user.userInfo.type;
      this.obj.roleType = type;
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.getIndustryinfoById();
      },
      immediate: true,
    },
  },
  methods: {
    //获取广告
    getAdv() {
      getAdv({
        curPage: 1,
        limit: 10,
        type: this.advType,
      }).then((res) => {
		if(res.code == 0) this.advList = res.page.list;
      });
    },
    tonextdetail(id) {
      if ("null" != id && null != id && id > 0) {
        // window.location.href='info_detail?id='+id;
        this.reload();
        this.$router.push({
          path: "/info_detail",
          query: { id: id },
        });
      } else {
        this.$message({
          message: "没有更多了",
          duration: 1000,
        });
      }
    },
    //获取资讯详情
    getIndustryinfoById() {
      let id = this.$route.query.id;
      if (!id) return;
      getIndustryinfoById(id)
        .then((res) => {
          if(res.code == 0){
            this.newsInfo = res.data;
            this.getMate(res.data);
            this.newsInfo.content = this.newsInfo.content.replace(
              /<img/g,
              "<img style='width:100%;height:auto;'"
            );
            // console.log("更改之前")
            // console.log(this.newsInfo.content)
            // var parser = new DOMParser();
            // var lsDoc = parser.parseFromString(this.newsInfo.content,"text/html");
            // var video = lsDoc.getElementsByTagName('video')[0];
            // console.log("视频信息")
            // console.log(video)
            // video.setAttribute("controls",'');
            // // video.setAttribute("autoplay","true");
            // video.setAttribute("preload","auto");
            // this.newsInfo.content = lsDoc.outerHTML()
            // console.log("更改之后")
            // console.log(this.newsInfo.content)
            this.nextid = res.next.id;
            this.nexttitle = res.next.title;
          }
        })
        .catch((err) => {});
    },
    //获取推荐新闻  前端随机取4个展示
    getRecommendIndustryinfoList() {
      getIndustryinfoList({
        recommend: 1,
      })
        .then((res) => {
          this.allList = res.page.list;
          this.getRecommendRandomList(4);
        })
        .catch((err) => {});
    },
    getRecommendRandomList(length) {
      this.newsRecommendObj.newData = _.compact(
        getRandomArray(_.cloneDeep(this.allList), length)
      );
    },
    //资讯收藏
    goCollection() {
      let params = {
        goodsId: this.$route.query.id,
        goodsType: 2,
      };
      addCollection(params)
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              message: "收藏成功！",
              type: "success",
              duration: 1000,
            });
          }
        })
        .catch((err) => {});
    },
    //取消收藏
     callCancelcollection(){
       let params = {
          goodsid:this.$route.query.id,
          goodstype:"2"
       }
       cancelcollection(params).then((res)=>{
         if(res.code == 0){
            this.$message({
              type:"success",
              message:"取消收藏"
            })
         }
       }).catch((err)=>{})
     },

    //查看收藏状态
    getIscollection() {
      let params = {
        goodsid: this.$route.query.id,
        goodstype: 2,
      };
      iscollection(params)
        .then((res) => {
          if (res.code == 0) {
            this.status = res.data;
          }
        })
        .catch((err) => {});
    },
    keepTextStyle(val) {
      return (val + "").replace(/(<br[^>]*>|\s*)/g, "");
    },
    //seo优化
    getMate(data) {
      var metas = document.getElementsByTagName("meta");
      metas[0].name = "keywords";
      metas[0].content = data.seokeywords;
      metas[1].name = "description";
      metas[1].content = data.seodescription;
      document.getElementsByTagName("title")[0].innerText = data.title+'_智污邦环保服务平台';
    },
  },
};
</script>

<style scoped lang='less'>
/deep/.info_detail_desc img {
  margin-top: 15px;
}
/deep/.info_detail_desc p a{
  color: #333 !important;
  text-decoration:underline
}

.industry_information_content {
  display: flex;

  .info_detail {
    width: 70%;
    margin-right: 30px;
    h2 {
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
    }
    .info_detail_tips {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .info_detail_date {
        flex: 6;
        margin-top: 20px;
        max-width: 412px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        span {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          margin-right: 20px;
          &:last-of-type {
            margin-right: 0;
          }
        }
      }
      .user_operation {
        flex: 4;
      }
    }
    .info_detail_line {
      width: 100%;
      height: 1px;
      margin: 10px 0;
      background: #eeeeee;
    }
    .info_detail_desc {
      p {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 24px;
        text-indent: 2em;
        img {
          width: 100%;
          height: 364px;
          margin-top: 10px;
        }
      }
    }
    .info_detail_next {
      cursor: pointer;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      margin: 35px 0;
      &:hover {
        color: blue;
      }
    }
    .info_detail_statement {
      height: 50px;
      font-size: 14px;
      color: #333333;
      font-weight: 400;
      margin-top: 30px;
      &:hover {
        color: #ff4f4f;
      }
    }
  }

  .industry_information_recommender {
    width: 30%;
  }
  .find_right {
    width: 100%;
    position: relative;
    span {
      position: absolute;
      top: 5px;
      left: 5px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
    }
    img {
      width: 100%;
      height: 184px;
    }
  }
}

attribute {
    margin-top: 0px;
    margin-bottom: 0.2rem;
    padding: 0px;
    color: rgb(64, 64, 64);
    font-family: Arial, "Hiragino Sans GB", STHeiti, "Helvetica Neue", Helvetica, "Microsoft Yahei", "WenQuanYi Micro Hei", sans-serif;
    line-height: 36px;
    text-indent: 0em;
    font-size: 18px;
    white-space: normal;
    text-align: center;
    outline: none !important;
}
</style>



// WEBPACK FOOTER //
// src/view/industry_information/info_detail.vue